<div class="viewer">
  <div class="viewer-header">
    <button mat-icon-button [disabled]="index === 0" (click)="step(-1)" matTooltip="Previous">
      <fa-icon [icon]="faPrev"></fa-icon>
    </button>
    <div class="title">
      <div class="name">{{current?.fileName}}</div>
      <div class="count">{{index + 1}} of {{files.length}}</div>
    </div>
    <button mat-icon-button [disabled]="index === files.length - 1" (click)="step(1)" matTooltip="Next">
      <fa-icon [icon]="faNext"></fa-icon>
    </button>
    <button mat-icon-button [disabled]="!rawBase64" (click)="download()" matTooltip="Download">
      <fa-icon [icon]="faDownload"></fa-icon>
    </button>
    <button mat-icon-button (click)="close()" matTooltip="Close">
      <fa-icon [icon]="faClose"></fa-icon>
    </button>
  </div>

  <div class="viewer-body">
    <div *ngIf="isLoading" class="state"><mat-spinner [diameter]="36"></mat-spinner></div>
    <div *ngIf="loadFailed && !isLoading" class="state">This file could not be loaded.</div>

    <ng-container *ngIf="!isLoading && !loadFailed" [ngSwitch]="kind">
      <div *ngSwitchCase="'image'" class="image-wrap">
        <img [src]="imageSrc" [alt]="current.fileName">
      </div>

      <iframe *ngSwitchCase="'pdf'" class="pdf-frame" [src]="pdfUrl" title="PDF preview"></iframe>

      <div *ngSwitchCase="'excel'" class="excel-wrap">
        <mat-tab-group animationDuration="0ms" *ngIf="sheets.length">
          <mat-tab *ngFor="let sheet of sheets" [label]="sheet.name">
            <ng-template matTabContent>
              <div *ngIf="sheet.rows.length === 0" class="state">This sheet is empty.</div>
              <ejs-grid *ngIf="sheet.rows.length" [dataSource]="sheet.rows" [columns]="sheet.columns"
                [allowSorting]="true" [allowResizing]="true" [enableHover]="false" [allowSelection]="false"
                [allowPaging]="true" [pageSettings]="{ pageSize: 100 }" rowHeight="30" height="55vh">
              </ejs-grid>
              <div *ngIf="sheet.truncated" class="truncated">
                Showing the first 5,000 rows. Download the file to see everything.
              </div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>

      <div *ngSwitchDefault class="state other">
        <fa-icon [icon]="faFile" size="3x"></fa-icon>
        <div>No preview available for this file type.</div>
        <button mat-raised-button color="primary" (click)="download()">Download</button>
      </div>
    </ng-container>
  </div>
</div>
